import DcProcessLogsBase from "./ProcessLogsBase/DcProcessLogsBase"

const DataCollectionProcessLogs = () => {
  return (
    <div>
      <DcProcessLogsBase />
    </div>
  )
}

export default DataCollectionProcessLogs